const OCCUPANCY_TYPES = [
	'Primary Residence',
	'Second Home',
	'Investment Property'
];

export default OCCUPANCY_TYPES;
